import { javaApi } from "../api/axios";

// Support ticket API endpoints
export const fetchSupportTickets = async (filters = {}) => {
  try {
    const response = await javaApi.get('/api/v1/support/tickets', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error fetching support tickets:', error);
    throw error;
  }
};

export const fetchSupportTicketDetail = async (ticketId) => {
  try {
    const response = await javaApi.get(`/api/v1/support/tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching support ticket detail:', error);
    throw error;
  }
};

export const createSupportTicket = async (ticketData) => {
  try {
    const response = await javaApi.post('/api/v1/support/tickets', ticketData);
    return response.data;
  } catch (error) {
    console.error('Error creating support ticket:', error);
    throw error;
  }
};

export const updateSupportTicketStatus = async (ticketId, status) => {
  try {
    const response = await javaApi.put(`/api/v1/support/tickets/${ticketId}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Error updating support ticket status:', error);
    throw error;
  }
};

export const fetchTicketChatMessages = async (threadUuid) => {
  try {
    const response = await javaApi.get(`/api/v1/support/thread/${threadUuid}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching chat messages:', error);
    throw error;
  }
};

export const sendTicketChatMessage = async (threadUuid, messageData) => {
  try {
    const response = await javaApi.post(`/api/v1/support/thread/${threadUuid}/messages`, messageData);
    return response.data;
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};

export const assignTicketToAgent = async (ticketId, agentId) => {
  try {
    const response = await javaApi.patch(`/api/v1/support/tickets/${ticketId}/assign`, { agent_id: agentId });
    return response.data;
  } catch (error) {
    console.error('Error assigning ticket to agent:', error);
    throw error;
  }
};

export const updateTicketPriority = async (ticketId, priority) => {
  try {
    const response = await javaApi.patch(`/api/v1/support/tickets/${ticketId}/priority`, { priority });
    return response.data;
  } catch (error) {
    console.error('Error updating ticket priority:', error);
    throw error;
  }
};